import { useEffect, useState, useRef } from "react";
import { CourseCards } from './CourseCards';
import { useTranslation } from 'react-i18next';
import { SliderBigIMG } from './SliderBigIMG';
import './AboutUs.css';
import { useAppTranslation } from "./TranslationContext";

export const Primary = () => {
  const { i18n } = useTranslation();
  const { t } = useAppTranslation();
  const [slidesData, setSlidesData] = useState([]);
  const [currentSlide, setCurrentSlide] = useState(0);
  const autoSlideTimeout = useRef(null);

  const [author, setAuthor] = useState(null);
  const [authorLoading, setAuthorLoading] = useState(true);
  const [authorError, setAuthorError] = useState(null);

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  // Получаем данные с сервера
  useEffect(() => {
    fetch("https://api.eduskill.uz/api/main/")
      .then((res) => res.json())
      .then((data) => {
        // Если сервер вернёт массив, работаем напрямую
        // Если объект — оборачиваем в массив
        const slides = Array.isArray(data) ? data : [data];

        // Мапим данные под формат слайдера
        const mappedSlides = slides.map(item => {
          const lang = i18n.language; // текущий язык (ru, uz, en)
          return {
            hero: item[`img_uz`] || item.img_uz, // fallback на узбекский
            bg: "/images/Group 3.png", // фоновое изображение — можешь заменить на поле из API, если будет
            quote: item[`comment_${lang}`] || item.comment_uz,
            name: item[`yunalish_${lang}`] || item.yunalish_uz
          };
        });

        setSlidesData(mappedSlides);
      })
      .catch((err) => {
        console.error("Ошибка загрузки слайдов:", err);
      });
  }, [i18n.language]); // перезапрос при смене языка

  // Автопереключение
  useEffect(() => {
    if (slidesData.length === 0) return;

    autoSlideTimeout.current = setTimeout(() => {
      setCurrentSlide((prev) => (prev + 1) % slidesData.length);
    }, 9000);

    return () => clearTimeout(autoSlideTimeout.current);
  }, [currentSlide, slidesData]);

  useEffect(() => {
    const controller = new AbortController();
  
    const fetchAuthor = async () => {
      try {
        setAuthorLoading(true);
  
        // 1) тянем всех кастом-пользователей (без серверного фильтра)
        const res = await fetch('https://api.eduskill.uz/api/custom-users/', {
          signal: controller.signal
        });
        if (!res.ok) throw new Error('Ошибка загрузки списка профилей');
  
        const raw = await res.json();
  
        // 2) нормализуем ответ: [..] ИЛИ {results:[..]}
        const list = Array.isArray(raw)
          ? raw
          : (Array.isArray(raw?.results) ? raw.results : (raw ? [raw] : []));
  
        if (!Array.isArray(list) || list.length === 0) {
          throw new Error('Профили не найдены');
        }
  
        // 3) фильтруем по ilmiy_daraja === 3 (строка/число)
        const filtered = list.filter(p => Number(p?.ilmiy_daraja) === 3);
  
        // если таких нет — можно выбрать первый как запасной вариант
        const profile = filtered[0] ?? list[0];
        if (!profile) throw new Error('Подходящий профиль не найден');
  
        // 4) user может быть id или уже объектом
        let userObj = null;
        if (profile.user && typeof profile.user === 'object') {
          userObj = profile.user;
        } else if (profile.user != null) {
          // 4.1) тянем базового пользователя по id
          const ures = await fetch(`https://api.eduskill.uz/api/users/${profile.user}/`, {
            signal: controller.signal
          });
          if (!ures.ok) throw new Error('Ошибка загрузки данных пользователя автора');
          userObj = await ures.json();
        }
  
        // 5) собираем удобный объект
        const fullName = `${userObj?.first_name || ''} ${userObj?.last_name || ''}`.trim() || userObj?.username || '';
  
        setAuthor({
          id: profile.id,
          fullName,
          patronymic: profile.otasining_ismi ?? '',   // отчество
          img: profile.img || '/images/author-fallback.jpg',
          description: profile.description ?? '',
          email: userObj?.email ?? '',
          ilmiy_daraja: profile.ilmiy_daraja ?? null,
          til: profile.til ?? null
        });
  
        setAuthorError(null);
      } catch (e) {
        if (e.name !== 'AbortError') {
          setAuthorError(e.message || 'Неизвестная ошибка');
        }
      } finally {
        setAuthorLoading(false);
      }
    };
  
    fetchAuthor();
    return () => controller.abort();
  }, []);
  
  

  return (
    <>
      <div className="primary">
        {/* <div className="primary__content">
          <h1 className="primary__title">{t('primaryTitle')}</h1>
          <p className="primary__subtitle">{t('primarySubtitle')}</p>
        </div> */}

        <div className="slider">
          <div className="slides">
            {slidesData.map((slide, index) => (
              <div key={index} className={`slide ${index === currentSlide ? "active" : ""}`}>
                <div className="primary__content">
                  <h1 className="primary__title">{slide.quote}</h1>
                  <p className="primary__subtitle">{slide.name}</p>
                </div>
                {/* <img className="slide__hero" src={slide.hero} alt={`Character ${index + 1}`} /> */}
                <img className="slide__bg" src={slide.hero} alt="" />
                {/* <div className="slide__content">
                  <img src="/images/quote.png" alt="quote icon" />
                  <div className="quote">{slide.quote}</div>
                  <div className="name">{slide.name}</div>
                </div> */}
              </div>
            ))}
          </div>

          <div className="dots" id="dots">
            {slidesData.map((_, index) => (
              <span
                key={index}
                className={`dot ${index === currentSlide ? "active" : ""}`}
                onClick={() => goToSlide(index)}
              ></span>
            ))}
          </div>
        </div>
      </div>

      <CourseCards />

      <div className="about-page">
      <section className="author">
        <h2>{t('author')}</h2>

        {authorLoading && <p>Загрузка автора…</p>}
        {authorError && <p className="error">{authorError}</p>}

        {!authorLoading && !authorError && author && (
          <div className="author-block">
            <img
              src={author.img || '/images/author-fallback.jpg'}
              alt={author.fullName || 'author'}
              className="author-img"
            />
            <div className="author-content">
              <p className="author-name">
                {author.fullName}
                {author.patronymic ? ` ${author.patronymic}` : ''}
              </p>


              {/* язык — если нужен */}
              {/* <p className="author-lang">{langMap[author.til]}</p> */}

              <p className="author-desc">{author.description}</p>

              {/* email — по желанию */}
              {author.email && <p className="author-email">{author.email}</p>}
            </div>
          </div>
        )}
      </section>

      </div>
      

      {/* Преимущества */}
      <div className="about-page">
        <section className="features">
          <h2 className="prim__title">{t('whyWe')}</h2>
          <ul className='features-list'>
            <li className='features-item'>
              <img src="/images/1.gif" alt="" />
              <span>{t('why1')}</span>
            </li>
            <li className='features-item'>
              <img src="/images/2.gif" alt="" />
              <span>{t('why2')}</span>
            </li>
            <li className='features-item'>
              <img src="/images/3.gif" alt="" />
              <span>{t('why3')}</span>
            </li>
            <li className='features-item'>
              <img src="/images/4.gif" alt="" />
              <span>{t('why4')}</span>
            </li>
          </ul>
        </section>

        
      </div>


      <SliderBigIMG />

      
    </>
  );
};
